/**
 * B2-RIDE - OpenAPI 3.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2.0.0
 * Contact: mobile@pikyrent.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AlarmActive } from '../model/alarmActive';
import { AlarmType } from '../model/alarmType';
import { BulkCloseResponse } from '../model/bulkCloseResponse';
import { CloseBulkBody } from '../model/closeBulkBody';
import { CloseIdBody } from '../model/closeIdBody';
import { PaginatedResults } from '../model/paginatedResults';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class AlarmApiService {

    protected basePath = 'https://app-tst.pikyrent.com:33443';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Bulk close alarms
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bulkCloseAlarms(body: CloseBulkBody, observe?: 'body', reportProgress?: boolean): Observable<BulkCloseResponse>;
    public bulkCloseAlarms(body: CloseBulkBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BulkCloseResponse>>;
    public bulkCloseAlarms(body: CloseBulkBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BulkCloseResponse>>;
    public bulkCloseAlarms(body: CloseBulkBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling bulkCloseAlarms.');
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<BulkCloseResponse>('post',`${this.basePath}/alarm/close/bulk`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Close a single alarm
     * 
     * @param id Alarm ID
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public closeAlarm(id: number, body?: CloseIdBody, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public closeAlarm(id: number, body?: CloseIdBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public closeAlarm(id: number, body?: CloseIdBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public closeAlarm(id: number, body?: CloseIdBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling closeAlarm.');
        }


        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/alarm/close/${encodeURIComponent(String(id))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Export managed alarms as CSV
     * 
     * @param alarmTypeId 
     * @param cityId 
     * @param vehicle 
     * @param sort 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportManagedAlarmsCsv(alarmTypeId?: number, cityId?: number, vehicle?: string, sort?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public exportManagedAlarmsCsv(alarmTypeId?: number, cityId?: number, vehicle?: string, sort?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public exportManagedAlarmsCsv(alarmTypeId?: number, cityId?: number, vehicle?: string, sort?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public exportManagedAlarmsCsv(alarmTypeId?: number, cityId?: number, vehicle?: string, sort?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (alarmTypeId !== undefined && alarmTypeId !== null) {
            queryParameters = queryParameters.set('alarmTypeId', <any>alarmTypeId);
        }
        if (cityId !== undefined && cityId !== null) {
            queryParameters = queryParameters.set('cityId', <any>cityId);
        }
        if (vehicle !== undefined && vehicle !== null) {
            queryParameters = queryParameters.set('vehicle', <any>vehicle);
        }
        if (sort !== undefined && sort !== null) {
            queryParameters = queryParameters.set('sort', <any>sort);
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/csv'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<string>('get',`${this.basePath}/alarm/managed/csv`,
            {
                params: queryParameters,
                responseType: 'text' as 'json',
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    public exportHistoryAlarmsCsv(alarmTypeId?: number, cityId?: number, vehicle?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (alarmTypeId !== undefined && alarmTypeId !== null) {
            queryParameters = queryParameters.set('alarmTypeId', <any>alarmTypeId);
        }
        if (cityId !== undefined && cityId !== null) {
            queryParameters = queryParameters.set('cityId', <any>cityId);
        }
        if (vehicle !== undefined && vehicle !== null) {
            queryParameters = queryParameters.set('vehicle', <any>vehicle);
        }

        let headers = this.defaultHeaders;
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }
        headers = headers.set('Accept', 'text/csv');

        return this.httpClient.request<string>('get', `${this.basePath}/alarm/history/csv`,
            {
                params: queryParameters,
                responseType: 'text' as 'json',
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Export unmanaged alarms as CSV
     * 
     * @param alarmTypeId 
     * @param cityId 
     * @param vehicle 
     * @param seen 
     * @param sort 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportUnmanagedAlarmsCsv(alarmTypeId?: number, cityId?: number, vehicle?: string, seen?: boolean, sort?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public exportUnmanagedAlarmsCsv(alarmTypeId?: number, cityId?: number, vehicle?: string, seen?: boolean, sort?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public exportUnmanagedAlarmsCsv(alarmTypeId?: number, cityId?: number, vehicle?: string, seen?: boolean, sort?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public exportUnmanagedAlarmsCsv(alarmTypeId?: number, cityId?: number, vehicle?: string, seen?: boolean, sort?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (alarmTypeId !== undefined && alarmTypeId !== null) {
            queryParameters = queryParameters.set('alarmTypeId', <any>alarmTypeId);
        }
        if (cityId !== undefined && cityId !== null) {
            queryParameters = queryParameters.set('cityId', <any>cityId);
        }
        if (vehicle !== undefined && vehicle !== null) {
            queryParameters = queryParameters.set('vehicle', <any>vehicle);
        }
        if (seen !== undefined && seen !== null) {
            queryParameters = queryParameters.set('seen', <any>seen);
        }
        if (sort !== undefined && sort !== null) {
            queryParameters = queryParameters.set('sort', <any>sort);
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/csv'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<string>('get',`${this.basePath}/alarm/unmanaged/csv`,
            {
                params: queryParameters,
                responseType: 'text' as 'json',
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    public exportActiveAlarmsCsv(alarmTypeId?: number, cityId?: number, vehicle?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (alarmTypeId !== undefined && alarmTypeId !== null) {
            queryParameters = queryParameters.set('alarmTypeId', <any>alarmTypeId);
        }
        if (cityId !== undefined && cityId !== null) {
            queryParameters = queryParameters.set('cityId', <any>cityId);
        }
        if (vehicle !== undefined && vehicle !== null) {
            queryParameters = queryParameters.set('vehicle', <any>vehicle);
        }

        let headers = this.defaultHeaders;
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }
        headers = headers.set('Accept', 'text/csv');

        return this.httpClient.request<string>('get', `${this.basePath}/alarm/active/csv`,
            {
                params: queryParameters,
                responseType: 'text' as 'json',
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List all alarm types
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listAllAlarmTypes(observe?: 'body', reportProgress?: boolean): Observable<Array<AlarmType>>;
    public listAllAlarmTypes(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AlarmType>>>;
    public listAllAlarmTypes(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AlarmType>>>;
    public listAllAlarmTypes(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<AlarmType>>('get',`${this.basePath}/alarm/types`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List all alarms
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listAllAlarms(observe?: 'body', reportProgress?: boolean): Observable<Array<AlarmActive>>;
    public listAllAlarms(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AlarmActive>>>;
    public listAllAlarms(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AlarmActive>>>;
    public listAllAlarms(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<AlarmActive>>('get',`${this.basePath}/alarm/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List managed (closed) alarms with filters and pagination
     * 
     * @param page Page number (1-based)
     * @param limit Items per page
     * @param sort Comma-separated sort fields. Prefix with - for DESC (e.g. -id)
     * @param alarmTypeId 
     * @param cityId 
     * @param vehicle 
     * @param deviceId 
     * @param rentalId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listAllManagedAlarms(page?: number, limit?: number, sort?: string, alarmTypeId?: number, cityId?: number, vehicle?: string, deviceId?: number, rentalId?: number, observe?: 'body', reportProgress?: boolean): Observable<PaginatedResults>;
    public listAllManagedAlarms(page?: number, limit?: number, sort?: string, alarmTypeId?: number, cityId?: number, vehicle?: string, deviceId?: number, rentalId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaginatedResults>>;
    public listAllManagedAlarms(page?: number, limit?: number, sort?: string, alarmTypeId?: number, cityId?: number, vehicle?: string, deviceId?: number, rentalId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaginatedResults>>;
    public listAllManagedAlarms(page?: number, limit?: number, sort?: string, alarmTypeId?: number, cityId?: number, vehicle?: string, deviceId?: number, rentalId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {









        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (sort !== undefined && sort !== null) {
            queryParameters = queryParameters.set('sort', <any>sort);
        }
        if (alarmTypeId !== undefined && alarmTypeId !== null) {
            queryParameters = queryParameters.set('alarmTypeId', <any>alarmTypeId);
        }
        if (cityId !== undefined && cityId !== null) {
            queryParameters = queryParameters.set('cityId', <any>cityId);
        }
        if (vehicle !== undefined && vehicle !== null) {
            queryParameters = queryParameters.set('vehicle', <any>vehicle);
        }
        if (deviceId !== undefined && deviceId !== null) {
            queryParameters = queryParameters.set('deviceId', <any>deviceId);
        }
        if (rentalId !== undefined && rentalId !== null) {
            queryParameters = queryParameters.set('rentalId', <any>rentalId);
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PaginatedResults>('get',`${this.basePath}/alarm/managed`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List unmanaged (open) alarms with filters and pagination
     * 
     * @param page Page number (1-based)
     * @param limit Items per page
     * @param sort Comma-separated sort fields. Prefix with - for DESC (e.g. -id,seen). Allowed fields: id, seen, closed, server_time, generatedAt, alarmTypeId, deviceId, rentalId, cityId, alarmType.name, device.name
     * @param alarmTypeId Filter by alarm type ID
     * @param cityId Filter by city ID
     * @param vehicle Filter by device name, ID or IMEI (partial match)
     * @param seen Filter by seen status
     * @param deviceId Filter by device ID
     * @param rentalId Filter by rental ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listAllUnmanagedAlarms(page?: number, limit?: number, sort?: string, alarmTypeId?: number, cityId?: number, vehicle?: string, seen?: boolean, deviceId?: number, rentalId?: number, observe?: 'body', reportProgress?: boolean): Observable<PaginatedResults>;
    public listAllUnmanagedAlarms(page?: number, limit?: number, sort?: string, alarmTypeId?: number, cityId?: number, vehicle?: string, seen?: boolean, deviceId?: number, rentalId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaginatedResults>>;
    public listAllUnmanagedAlarms(page?: number, limit?: number, sort?: string, alarmTypeId?: number, cityId?: number, vehicle?: string, seen?: boolean, deviceId?: number, rentalId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaginatedResults>>;
    public listAllUnmanagedAlarms(page?: number, limit?: number, sort?: string, alarmTypeId?: number, cityId?: number, vehicle?: string, seen?: boolean, deviceId?: number, rentalId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {










        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (sort !== undefined && sort !== null) {
            queryParameters = queryParameters.set('sort', <any>sort);
        }
        if (alarmTypeId !== undefined && alarmTypeId !== null) {
            queryParameters = queryParameters.set('alarmTypeId', <any>alarmTypeId);
        }
        if (cityId !== undefined && cityId !== null) {
            queryParameters = queryParameters.set('cityId', <any>cityId);
        }
        if (vehicle !== undefined && vehicle !== null) {
            queryParameters = queryParameters.set('vehicle', <any>vehicle);
        }
        if (seen !== undefined && seen !== null) {
            queryParameters = queryParameters.set('seen', <any>seen);
        }
        if (deviceId !== undefined && deviceId !== null) {
            queryParameters = queryParameters.set('deviceId', <any>deviceId);
        }
        if (rentalId !== undefined && rentalId !== null) {
            queryParameters = queryParameters.set('rentalId', <any>rentalId);
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PaginatedResults>('get',`${this.basePath}/alarm/unmanaged`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Mark alarm as seen
     * 
     * @param id Alarm ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setAlarmAsSeen(id: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public setAlarmAsSeen(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public setAlarmAsSeen(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public setAlarmAsSeen(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling setAlarmAsSeen.');
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('post',`${this.basePath}/alarm/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
